import * as React from 'react';

import { Button, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface NavigationButtonProps {
  onClick: () => void;
  label: string;
}

const NavigationButton: React.FC<NavigationButtonProps> = ({ onClick, label }) => {
  return (
    <div id="hide-webview" className="h-[60px] md:h-[84px] flex items-center">
      <Button
        onClick={onClick}
        size="large"
        variant="text"
        color="primary"
        className="px-0 hover:bg-transparent"
      >
        <Typography
          variant="button-l"
          component="p"
          color="primary"
          className="transition ease-in-out hover:text-primary-light"
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 20, paddingRight: 0.5 }} />
          {label}
        </Typography>
      </Button>
    </div>
  );
};

export default NavigationButton;
